import { useState, useEffect } from "react"

function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState()

  useEffect(() => {
    function setWidth() {
      setWindowWidth(window.innerWidth)
    }

    setWidth()
    window.addEventListener("resize", setWidth)
    return () => window.removeEventListener("resize", setWidth)
  }, [setWindowWidth])

  return windowWidth
}

export default useWindowWidth
